import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText, Badge, Tooltip } from '@material-ui/core';
import Context from 'components/DuvidasFrequentes/Context';
import { PerguntaResponse } from 'api/Associado/duvidas';
import useDuvidasStyles from './style';

interface Props {
  onlyPrivate?: boolean;
  searchTerm?: string;
}

export default function ({ onlyPrivate, searchTerm }: Props) {
  const { t } = useTranslation();
  const { perguntas, answer } = useContext(Context);
  const classes = useDuvidasStyles();

  const getTooltip = (pergunta: PerguntaResponse) => {
    return !pergunta.resposta?.length
      ? 'AssembleiaAssociadoRoute.faq.tooltipPergunta'
      : 'AssembleiaAssociadoRoute.faq.tooltipResposta';
  };

  const currentQuestions = useMemo(() => {
    if (!perguntas) return [];
    return onlyPrivate ? perguntas.usuario : perguntas.publicas;
  }, [perguntas, onlyPrivate]);

  return (
    <List className={classes.list}>
      {currentQuestions
        .sort((a, b) => new Date(b.dataPergunta).getTime() - new Date(a.dataPergunta).getTime())
        .filter(question => {
          if (searchTerm) {
            return question.pergunta.toLowerCase().includes(searchTerm.toLowerCase());
          }
          return true;
        })
        .map(question => (
          <Tooltip key={question.idPergunta} title={t(getTooltip(question)) as string} arrow>
            <ListItem
              component="li"
              className={[classes.item, question.destaque ? classes.itemDestaque : ''].join(' ').trim()}
              onClick={() => answer(question.idPergunta, !onlyPrivate)}
              button
            >
              <ListItemText
                primary={
                  <Badge
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    variant="dot"
                    color="error"
                    badgeContent={onlyPrivate && question.resposta !== null && !question.lido ? 1 : 0}
                    className={classes.itemBadge}
                  >
                    {question.pergunta}
                  </Badge>
                }
                secondary={t('AssembleiaAssociadoRoute.faq.comment-by', {
                  who: question.usuarioPergunta,
                })}
                className={classes.itemText}
              />
            </ListItem>
          </Tooltip>
        ))}
    </List>
  );
}
